import Typography from '@classify/react-core-components/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { translate } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';

const Wrapper = styled('div')(({ theme: { spacing, palette } }) => ({
  padding: spacing(2),
  display: 'flex',
  alignItems: 'center',
  position: 'sticky',
  zIndex: 1,
  top: 0,
  background: palette.background.primary,
  borderBottom: `1px solid ${palette.line}`,
}));

export interface TocHeaderProps {
  onClose: () => void;
}

const TocHeader = ({ onClose }: TocHeaderProps) => (
  <Wrapper>
    <Typography sx={{ flexGrow: 1 }} variant="h6" component="h2">
      {translate('course_toc.title')}
    </Typography>
    <IconButton onClick={onClose} aria-label={translate('global.action.close_button')} size="large">
      <CloseIcon />
    </IconButton>
  </Wrapper>
);

export default TocHeader;
